module.exports = __webpack_public_path__ + "img/body-bg.643deae5.png";